import SpriteSymbol from "../../../../../../../node_modules/normacs_web/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/normacs_web/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "normacs-logo",
  "use": "normacs-logo-usage",
  "viewBox": "0 0 160 160",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 160 160\" id=\"normacs-logo\">\n  <g>\n    <path fill=\"currentColor\" d=\"M96 1.634v54.623l-.525-.015c-24.629-.065-35.087-.065-35.117 25.713v76.68H1V56.394C1 26.238 27.652 1.71 60.23 1.71L96 1.634z\" />\n    <path d=\"M64 158v-54.762l.786.01c24.642.068 34.816.068 34.854-25.71V1H159v102.092c0 30.163-26.655 54.832-59.23 54.832L64 158z\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol